import global from "@/locales/it-CH/global";
import error403 from "@/locales/it-CH/errors/403";
import error404 from "@/locales/it-CH/errors/404";
import error500 from "@/locales/it-CH/errors/500";
import error503 from "@/locales/it-CH/errors/503";
import error504 from "@/locales/it-CH/errors/504";
import maintenance from "@/locales/it-CH/auth/maintenance";
import toast from "@/locales/it-CH/toast/toast";
import login from "@/locales/it-CH/auth/login";
import onboarding from "@/locales/it-CH/auth/onboarding";
import loginPageSteps from "@/locales/it-CH/loginPageSteps";
import dashboard from "@/locales/it-CH/dashboard/dashboard";
import account from "@/locales/it-CH/account/account";
import mailbox from "@/locales/it-CH/account/mailbox";
import bankstatement from "@/locales/it-CH/account/bankstatement";
import myApps from "@/locales/it-CH/my-apps/myApps";
import about from "@/locales/it-CH/about/about";
import contactService from "@/locales/it-CH/about/contactService";
import salesPromotions from "@/locales/it-CH/sales/promotions";
import brochures from "@/locales/it-CH/sales/brochures";
import shop from "@/locales/it-CH/shop/data";
import priceList from "@/locales/it-CH/shop/priceList";
import staff from "@/locales/it-CH/dashboard/staff";
import promotions from "@/locales/it-CH/promotions";
import points from "@/locales/it-CH/points";
import trainings from "@/locales/it-CH/trainings/trainings";
import vouchers from "@/locales/it-CH/vouchers/vouchers";
import generateReport from "@/locales/it-CH/generate-report/generateReport";
import widgets from "@/locales/it-CH/widgets/widgets";
import wholesaler from "@/locales/it-CH/wholesaler/wholesaler";
import media from "@/locales/it-CH/media/index";
import onlineVisibility from "@/locales/it-CH/sales/onlineVisibility";
import fuelCalculator from "@/locales/it-CH/sales/fuelCalculator";
import product from "@/locales/it-CH/product/index";
import message from "@/locales/it-CH/message/index";
import commitmentLetter from "@/locales/it-CH/account/commitmentLetter";
import multiplicator from "@/locales/it-CH/multiplicator";
import consents from "@/locales/it-CH/consents/consents";
import investment from "@/locales/it-CH/investment/data";
import kickback from "@/locales/it-CH/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  onlineVisibility: onlineVisibility.messages,
  priceList: priceList.messages,
  fuelCalculator: fuelCalculator.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Immagini dei prodotti",
    BDriveLinkText: "Link al portale IMMAGINI PRODOTTI",
  },
}

export default {
  locale: "it-CH",
  messages,
};
